import React, { FC, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { Input } from '@eika/input';
import { Loader } from '@eika/loader';

import { EiendomskildeWeb, EiendomWeb, ValgtWeb } from '../../generated-types';
import { usePoststed } from '../../hooks/useEiendom';
import { useTranslation } from '../../translations';

export const ANNEN_EIENDOM_ID = 'annen';

export const annenEiendom: EiendomWeb = {
    adresse: null,
    borettslagAndelWeb: null,
    bruk: null,
    eiendomId: ANNEN_EIENDOM_ID,
    id: null,
    harEksterneHeftelserEllerKrysspant: false,
    uuid: '',
    kilde: EiendomskildeWeb.KUNDE,
    matrikkelWeb: null,
    overtakelsesDato: null,
    postnummer: null,
    poststed: null,
    type: null,
    variant: null,
    oenskerVerdivurdering: ValgtWeb.IKKE_VALGT,
    eiendomsverdiWeb: null,
    etakstWeb: null,
    laaneformaal: [],
    annetLaaneformaal: null,
};

export type AnnenEiendomFormData = {
    adresse: string | null;
    postnummer: string | null;
    poststed: string | null;
};

const AnnenEiendom: FC = () => {
    const { annenEiendom, validationMessage } = useTranslation();
    const {
        register,
        setValue,
        watch,
        formState: { errors },
    } = useFormContext<AnnenEiendomFormData>();
    const { postnummer } = watch();
    const { data: poststed, isLoading, isFetched } = usePoststed(postnummer);

    useEffect((): void => {
        register('poststed', { required: `${validationMessage.invalidPostnummer}` });
    }, [isFetched, register, validationMessage]);

    useEffect((): void => {
        if (isFetched) {
            setValue('poststed', poststed?.value || null, { shouldValidate: true, shouldDirty: true });
        }
    }, [isFetched, setValue, poststed]);

    return (
        <>
            <Input
                label={annenEiendom.labelGateadresse}
                className="max-width-400"
                error={errors.adresse?.message?.toString()}
                {...register('adresse', { required: `${validationMessage.requiredValue}` })}
            />
            <div className="column column-gap align-items-end">
                <Input
                    inputMode="numeric"
                    label={annenEiendom.labelPostnummer}
                    type="tel"
                    className="max-width-200"
                    error={errors.postnummer?.message?.toString() || errors.poststed?.message?.toString()}
                    {...register('postnummer', {
                        required: `${validationMessage.requiredValue}`,
                        minLength: { value: 4, message: `${validationMessage.postnummerToShort}` },
                        maxLength: { value: 4, message: `${validationMessage.postnummerToLong}` },
                    })}
                />
                {isLoading ? (
                    <span className="max-width-100">
                        <Loader mini />
                    </span>
                ) : (
                    <span style={{ paddingBottom: '11px' }}>{poststed?.value}</span>
                )}
            </div>
        </>
    );
};

export default AnnenEiendom;
